module.exports = __webpack_public_path__ + "img/concreted_asphalted.5aa62fa7.png";